export default __webpack_public_path__ + "static/media/house.cfaf8c3c.png";